module.exports = __webpack_public_path__ + "static/media/my-education.3ef628f8.svg";